import { AxiosError } from "axios";
import { Dispatcher } from "../../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { NavigateFunction } from "react-router-dom";
import { addSelectedAndDetectionTypeOnRefresh } from "./addSelectedAndDetectionTypeOnRefresh";
import { universalAPIErrorHandler } from "../../../utils/universalAPIErrorHandler";
import { checkIfCurrentDate } from "./checkIfCurrentDate";
import { timeSlicer } from "../timeSlicer";
import { numberListToString } from "./getAlertsWithQuerry";
import { getAlertsRefreshNoNetworkError } from "./getAlertsRefreshNoNetworkError";
import { getRefreshToken } from "../../../utils/getRefreshToken";
import { alertService } from "../../../../services/api/alertService";
import { recordGroupAlertSnapshot } from "../AlertsStore/alertsScopeStore";

const isAlertsUrl = () => {
  const currentUrl = window.location.href;
  return currentUrl.includes("alerts");
};

export const getAlertsRefresh = (
  setAlertData: Dispatcher<any>,
  navigate: NavigateFunction,
  groupId: string,
  siteId: number[],
  cameraId: number[],
  startDate: string,
  endDate: string,
  startTime: Date | null,
  endTime: Date | null,
  filterType: string,
  setSelectedRow: any,
  setRefreshingData: Dispatcher<boolean>,
  setSelectedAlertCameraInfo: any,
  setIgnoreZonesSelectedAlert: any,
  setAlertsIndexOrder: any,
  refreshInterval: any,
  setRefreshInterval: any,
  pageLoadedNumber: number,
  setSeeMoreURL: any,
  setMP4URL: any,
  setVideoClipLoading: any,
  setSelectedButtonsFilled: any,
  setAlertsToDisplay: any,
  setCurrentName: any,
  setPage: any,
  setDateOutsideRange: any,
  setFetchingFilteredData: any,
  setPageLoading: any,
  setUserFilters: any,
  userFilters: any,
  cameraOptions: any,
  siteOptions: any,
  startTimeStamp: any,
  setRefreshingToken: Dispatcher<boolean>,
  refreshingToken: boolean,
  previousLength: number,
  setBackArrowDisabled: any,
  setForwardArrowDisabled: any,
  setShowRefreshButton: any,
  setAlertsRefreshing: Dispatcher<boolean>,
  triggeredFromDetectionLabeling: boolean,
  getCurrentSelectedRowKey: () => string | null,
  setVideoProcessing?: Dispatcher<boolean>,
  useAsyncGeneration: boolean = true
) => {
  const retryFunction = () => {
    localStorage.tokenRefreshing === "false" &&
      getAlertsRefresh(
        setAlertData,
        navigate,
        groupId,
        siteId,
        cameraId,
        startDate,
        endDate,
        startTime,
        endTime,
        filterType,
        setSelectedRow,
        setRefreshingData,
        setSelectedAlertCameraInfo,
        setIgnoreZonesSelectedAlert,
        setAlertsIndexOrder,
        refreshInterval,
        setRefreshInterval,
        pageLoadedNumber,
        setSeeMoreURL,
        setMP4URL,
        setVideoClipLoading,
        setSelectedButtonsFilled,
        setAlertsToDisplay,
        setCurrentName,
        setPage,
        setDateOutsideRange,
        setFetchingFilteredData,
        setPageLoading,
        setUserFilters,
        userFilters,
        cameraOptions,
        siteOptions,
        startTimeStamp,
        setRefreshingToken,
        refreshingToken,
        previousLength,
        setBackArrowDisabled,
        setForwardArrowDisabled,
        setShowRefreshButton,
        setAlertsRefreshing,
        false,
        getCurrentSelectedRowKey,
        setVideoProcessing,
        useAsyncGeneration
      );
  };

  let searchingPastDates = false;

  let searchParamsString = ``;

  if (startDate) {
    searchParamsString += `&start=${startDate}`;
  }

  if (endDate) {
    searchParamsString += `&end=${endDate}`;
    searchingPastDates = checkIfCurrentDate(endDate);
  }

  if (groupId) {
    if (groupId !== "undefined") {
      searchParamsString += `&group_id=${groupId}`;
    }
  }

  if (siteId[0]) {
    searchParamsString += `&customer_id=${numberListToString(siteId)}`;
  }

  if (cameraId) {
    searchParamsString += `&camera_id=${numberListToString(cameraId)}`;
  }

  if (startDate.toString() === endDate.toString() && startTime !== null) {
    searchParamsString += `&start_time=${timeSlicer(startTime)}`;
  }

  if (startDate.toString() === endDate.toString() && endTime !== null) {
    searchParamsString += `&end_time=${timeSlicer(endTime)}`;
  }

  if (userFilters.has_video) {
    searchParamsString += `&has_video=true`;
  }

  localStorage.setItem(
    "queryString",
    JSON.stringify(`${filterType}${searchParamsString}`)
  );

  const areObjectsEqual = (
    obj1: Record<string, any>,
    obj2: Record<string, any>
  ): boolean => {
    for (const key in obj1) {
      if (obj1[key] !== null && obj2[key] !== null) {
        if (obj1[key].toString() !== obj2[key].toString()) {
          return false;
        }
      }
    }
    return true;
  };

  const filtersMatch = areObjectsEqual(
    userFilters,
    JSON.parse(localStorage.latestAlertFilters)
  );
  const pageNumbersMatch =
    Number(pageLoadedNumber) === Number(localStorage.pageLoadedNumber);
  const isAlertsPage = isAlertsUrl();
  const notSearchingPastDates = !searchingPastDates;
  const urlIncludesAlerts = location.href.includes("alerts");

  if (
    filtersMatch &&
    pageNumbersMatch &&
    isAlertsPage &&
    notSearchingPastDates &&
    urlIncludesAlerts
  ) {
    setAlertsRefreshing(true);
  }

  setTimeout(
    async () => {
      const filtersMatchTimeout = areObjectsEqual(
        userFilters,
        JSON.parse(localStorage.latestAlertFilters)
      );
      const pageNumbersMatchTimeout =
        Number(pageLoadedNumber) === Number(localStorage.pageLoadedNumber);
      const isAlertsPageTimeout = isAlertsUrl();
      const notSearchingPastDatesTimeout = !searchingPastDates;
      const urlIncludesAlertsTimeout = location.href.includes("alerts");

      if (
        filtersMatchTimeout &&
        pageNumbersMatchTimeout &&
        isAlertsPageTimeout &&
        notSearchingPastDatesTimeout &&
        urlIncludesAlertsTimeout
      ) {
        setAlertsRefreshing(true);
        try {
          const responseData = await alertService.getAlerts({
            filterType,
            searchParamsString,
          });

          recordGroupAlertSnapshot(
            responseData,
            groupId,
            filterType,
            searchParamsString
          );

          let previousTimeStamps = startTimeStamp;
          if (!responseData.records[0]) {
            setAlertData([]);
            setAlertsToDisplay(false);
            setRefreshingData(false);
          }
          if (responseData.records[0]) {
            previousTimeStamps =
              responseData.records[0].approx_capture_timestamp;
            if (
              previousTimeStamps !== startTimeStamp ||
              (previousTimeStamps === startTimeStamp &&
                responseData.records.length !== previousLength)
            ) {
              setRefreshingData(true);
              const newData = responseData;
              setAlertsToDisplay(true);
              if (
                JSON.parse(localStorage.queryString) ===
                `${filterType}${searchParamsString}`
              ) {
                setAlertData(
                  addSelectedAndDetectionTypeOnRefresh(
                    newData.records,
                    setAlertsIndexOrder,
                    setSeeMoreURL,
                    setSelectedRow,
                    setSelectedAlertCameraInfo,
                    setIgnoreZonesSelectedAlert,
                    navigate,
                    setMP4URL,
                    setVideoClipLoading,
                    setSelectedButtonsFilled,
                    newData,
                    setAlertData,
                    refreshingToken,
                    setBackArrowDisabled,
                    setForwardArrowDisabled,
                    setShowRefreshButton,
                    getCurrentSelectedRowKey,
                    setVideoProcessing,
                    useAsyncGeneration
                  )
                );
              }
              setRefreshingData(false);
            }
          }
          if (
            localStorage.tokenRefreshing === "false" ||
            localStorage.tokenRefreshing === undefined
          ) {
            setTimeout(() => {
              getAlertsRefresh(
                setAlertData,
                navigate,
                groupId,
                siteId,
                cameraId,
                startDate,
                endDate,
                startTime,
                endTime,
                filterType,
                setSelectedRow,
                setRefreshingData,
                setSelectedAlertCameraInfo,
                setIgnoreZonesSelectedAlert,
                setAlertsIndexOrder,
                refreshInterval,
                setRefreshInterval,
                pageLoadedNumber,
                setSeeMoreURL,
                setMP4URL,
                setVideoClipLoading,
                setSelectedButtonsFilled,
                setAlertsToDisplay,
                setCurrentName,
                setPage,
                setDateOutsideRange,
                setFetchingFilteredData,
                setPageLoading,
                setUserFilters,
                userFilters,
                cameraOptions,
                siteOptions,
                previousTimeStamps,
                setRefreshingToken,
                refreshingToken,
                responseData.records.length,
                setBackArrowDisabled,
                setForwardArrowDisabled,
                setShowRefreshButton,
                setAlertsRefreshing,
                false,
                getCurrentSelectedRowKey
              );
            }, refreshInterval);
          } else {
            setAlertsRefreshing(false);
          }
        } catch (error) {
          setRefreshingToken(true);
          universalAPIErrorHandler(
            error as AxiosError,
            navigate,
            () => {
              retryFunction();
              setRefreshingToken(false);
            },
            () => {
              getRefreshToken(
                navigate,
                getAlertsRefreshNoNetworkError(
                  setAlertData,
                  navigate,
                  groupId,
                  siteId,
                  cameraId,
                  startDate,
                  endDate,
                  startTime,
                  endTime,
                  filterType,
                  setSelectedRow,
                  setRefreshingData,
                  setSelectedAlertCameraInfo,
                  setIgnoreZonesSelectedAlert,
                  setAlertsIndexOrder,
                  refreshInterval,
                  setRefreshInterval,
                  pageLoadedNumber,
                  setSeeMoreURL,
                  setMP4URL,
                  setVideoClipLoading,
                  setSelectedButtonsFilled,
                  setAlertsToDisplay,
                  setCurrentName,
                  setPage,
                  setDateOutsideRange,
                  setFetchingFilteredData,
                  setPageLoading,
                  setUserFilters,
                  userFilters,
                  cameraOptions,
                  siteOptions,
                  startTimeStamp,
                  setRefreshingToken,
                  refreshingToken,
                  previousLength,
                  setBackArrowDisabled,
                  setForwardArrowDisabled,
                  setShowRefreshButton,
                  setAlertsRefreshing,
                  false,
                  getCurrentSelectedRowKey
                )
              );
            }
          );
        }
      } else {
        // Only set alertsRefreshing to false if we're not on the alerts page
        // or if we're searching past dates (which disables refresh)
        if (!isAlertsPage || !urlIncludesAlerts || searchingPastDates) {
          setAlertsRefreshing(false);
        }
      }
    },
    triggeredFromDetectionLabeling ? 0 : refreshInterval
  );
};
